import moment from 'moment'

import { formatTime } from './date'
import { PREVIEW_TIMEOUT_MS } from 'redux/slices/liveShow'
import { Show } from 'data/Show'

export const showHasStarted = (show: Show) => moment().isSameOrAfter(moment(show.startTime))

export const showHasEnded = (show: Show) => !!show.endTime && moment().isSameOrAfter(moment(show.endTime))

export const showIsSoldOut = (remainingPasses: number | null) => remainingPasses !== null && remainingPasses <= 0

export const getTimeForShowIntroduction = (startTime: string) => moment(startTime).subtract('30', 'minutes')

export const getMSBeforeShowIntroduction = (startTime: string) => {
    const showIntroduction = getTimeForShowIntroduction(startTime)
    return moment(showIntroduction).diff(moment(), 'milliseconds')
}

export const getMSBeforeShowStartTime = (startTime: string) => moment(startTime).diff(moment(), 'milliseconds')

export const isBeforeShowIntro = (startTime: string) => moment().isBefore(getTimeForShowIntroduction(startTime))
export const isAfterShowIntro = (startTime: string) => moment().isSameOrAfter(getTimeForShowIntroduction(startTime))

export const getFormattedShowStartTime = (startTime: string) =>
    `${moment(startTime).format('MMM DD')}, ${formatTime(startTime)}`

export const shouldStartPreview = (previewStartedAt: string) => {
    const previewEndTime = getPreviewEndTime(previewStartedAt)
    return moment().isSameOrBefore(previewEndTime)
}

export const getShowsBySeriesId = (shows: Show[] | null) => (seriesId: string) =>
    shows
        ? shows
              .filter(show => show.seriesId === seriesId)
              .sort((showLeft, showRight) => moment(showLeft.startTime).diff(moment(showRight.startTime)))
        : []

export const getPreviewEndTime = (previewStartedAt: string) => {
    const previewEndTime = moment(previewStartedAt)
        .clone()
        .add(PREVIEW_TIMEOUT_MS, 'ms')
    return previewEndTime.format()
}
